/*
*@/components/cat4mro/mro-invite-to-rfq
*/
export default {
  MroInviteToRfq: {
    p1: 'Your company do not possess',
    p2: 'the quote module.',
    p3: 'Please contact to',
    email: 'sales@unilinkcorp.com',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/cat4mro/components/mroInviteToRfq.js